import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import htmlReactParser from 'html-react-parser';

import Select from '../molecules/D3-sample-cart-select';

const row = (props) => {
  const {product, callbacks, labels} = props;
  const {select} = product;
  let type = null;
  let quantity = null;
  const description = product.description.length ?
    <p className="D3-sample-cart__description">{htmlReactParser(product.description)}</p> : null;

  if (product.type) {
    type = (
      <Fragment>
        <div className="D3-sample-cart__mobile-head">{labels.type}</div>
        <div className="D3-sample-cart__type select-group">
          <Select
            options={select.type}
            selected={product.type}
            id={product._id}
            update={callbacks.update}
            productKey="type"
          />
        </div>
      </Fragment>
    );
  }

  if (product.quantity) {
    quantity = (
      <Fragment>
        <div className="D3-sample-cart__mobile-head">{labels.quantity}</div>
        <div className="D3-sample-cart__quantity select-group">
          <Select
            options={select.qty}
            selected={product.quantity}
            id={product._id}
            update={callbacks.update}
            productKey="quantity"
          />
        </div>
      </Fragment>
    );
  }

  return (
    <div className="D3-sample-cart__table-row">
      <div className="D3-sample-cart__table-row-container">
        <div className="D3-sample-cart__table-cell">
          <h4 className="D3-sample-cart__title">{product.url ? (
            <a href={product.url}>{htmlReactParser(product.title)}</a>) : htmlReactParser(product.title)}</h4>
          {description}
        </div>
        <div className="D3-sample-cart__table-cell">
          <div className="D3-sample-cart__mobile-head">{labels.size}</div>
          <div className="D3-sample-cart__size">{product.size}</div>
        </div>
        <div className="D3-sample-cart__table-cell">
          {quantity}
        </div>
        <div className="D3-sample-cart__table-cell">
          {type}
        </div>
        <div className="D3-sample-cart__table-cell">
          <div className="D3-sample-cart__remove-button">
            <a href="/" className="D3-sample-cart__button" onClick={(event) => {
              return callbacks.remove(event, product._id);
            }}>{labels.removeButton}</a>
          </div>
        </div>
      </div>
    </div>
  );
};

row.propTypes = {
  product: PropTypes.shape({}),
  callbacks: PropTypes.shape({}),
  labels: PropTypes.shape({}),
};

row.defaultProps = {
  product: {},
  callbacks: {
    remove: () => {
    },
  },
  labels: {
    product: 'Products',
    size: 'Size',
    quantity: 'Qty',
    type: 'Type',
    removeButton: 'Remove',
  },
};

export default row;
